import { PRE_ASSESSMENT_STEP_PATHS } from '@/constants';
import QuestionnaireFlow from './QuestionnaireFlow';

export const getQuestionnaireFlow = ({ allQuestionnaires, back, next }) => {
  const questionnaires = Object.keys(allQuestionnaires)
    .filter(questionnaireKey => {
      const { triggerOn } = allQuestionnaires[questionnaireKey];
      return !triggerOn.highPml;
    })
    .map(questionnaireKey => ({
      path: PRE_ASSESSMENT_STEP_PATHS[`${questionnaireKey}_QUESTIONNAIRE`],
      prerequisite: 'hasAtLeastOneProduct',
      skip: ({ hasCategory, hasBusinessConcept, hasHighExposure }) => {
        const { triggerOn } = allQuestionnaires[questionnaireKey];

        return !(
          ((triggerOn.goodsCategories &&
            triggerOn.goodsCategories.some(goodsCategory => hasCategory(goodsCategory))) ||
            (triggerOn.businessConcepts &&
              triggerOn.businessConcepts.some(businessConcept =>
                hasBusinessConcept(businessConcept),
              ))) &&
          (!triggerOn.highExposure || hasHighExposure)
        );
      },
      id: questionnaireKey,
    }));
  return new QuestionnaireFlow({
    questionnaires,
    back,
    next,
  });
};
